import { motion } from "framer-motion";

const quotes = [
    {
        q: "We retired Slack, Notion, ClickUp & Zoho the same week. Our ops finally feel like one company.",
        a: "Léa Marchand",
        r: "COO · Helio Labs",
        c: "#3b82f6",
    },
    {
        q: "The AI Co‑pilot drafts our investor updates from live data. It's like a chief‑of‑staff that never sleeps.",
        a: "Marcus Wei",
        r: "CEO · Forge Robotics",
        c: "#fbbf24",
    },
    {
        q: "Pipeline, finance, projects, HR — every Monday review starts and ends inside ApexBrain.",
        a: "Priya Anand",
        r: "Head of Ops · Northwind",
        c: "#22c55e",
    },
    {
        q: "We replaced fifteen subscriptions with one platform. CFO is delighted. Engineers are faster.",
        a: "Jonas Krause",
        r: "VP Eng · Klarstrom",
        c: "#a78bfa",
    },
    {
        q: "The bento dashboard is genuinely the only screen our leadership team uses anymore. It's like a single pane of glass into the company.",
        a: "Aiko Tanaka",
        r: "Founder · Sumi & Co",
        c: "#f43f5e",
    },
    {
        q: "Onboarding used to take weeks across five tools. Now new hires are productive in days — everything lives in one workspace.",
        a: "Elena Vasquez",
        r: "People Lead · Meridian Systems",
        c: "#06b6d4",
    },
];

export const Testimonials = () => {
    return (
        <section
            id="testimonials"
            className="relative py-24 sm:py-32"
            data-testid="testimonials-section"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="max-w-3xl mb-14">
                    <p className="text-xs uppercase tracking-[0.25em] text-electric font-semibold mb-4">
                        TRUSTED BY OPERATORS
                    </p>
                    <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.06]">
                        Teams that ship,{" "}
                        <span className="text-zinc-500">run on ApexBrain.</span>
                    </h2>
                </div>

                <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
                    {quotes.map((t, i) => (
                        <motion.div
                            key={t.a}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.06 }}
                            className="break-inside-avoid mb-5 rounded-2xl bg-obsidian-200 border border-white/[0.06] hover:border-white/15 p-6 sm:p-7 transition-colors"
                            data-testid={`testimonial-${i}`}
                        >
                            <p className="text-zinc-200 text-base leading-relaxed font-light">
                                "{t.q}"
                            </p>
                            <div className="mt-6 flex items-center gap-3">
                                <span
                                    className="w-9 h-9 rounded-full"
                                    style={{ background: t.c }}
                                />
                                <div>
                                    <div className="text-sm font-semibold text-white">
                                        {t.a}
                                    </div>
                                    <div className="text-xs text-zinc-500">
                                        {t.r}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
